import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf0f910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = { class: "my-4 mx-4 p-0 bg-white border-radius-10" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center py-4" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "font-grey p-cursor text-center" }, [
      /*#__PURE__*/_createElementVNode("b", { style: {"color":"#6B7A99"} }, "Corporate Application")
    ])
  ])
], -1))
const _hoisted_7 = { class: "row my-3 justify-content-center" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_9 = { class: "container-fluid" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "list-unstyled multi-steps" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Personal", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Business", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "M.D. & Owners", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "External Bank Account", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "E-Signature", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Upload Proof", -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "row my-3 justify-content-center" }
const _hoisted_26 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_27 = { class: "login-card" }
const _hoisted_28 = { class: "login-body company" }
const _hoisted_29 = { class: "row mt-3" }
const _hoisted_30 = { class: "col-md-12 col-12" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Ref number by Caprock please enter it here.")
], -1))
const _hoisted_33 = { class: "col-md-12 col-12 d-none" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, [
  /*#__PURE__*/_createTextVNode(" Advisor Ref No"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "If you have been given a Advisor Ref number by Caprock please enter it here.")
], -1))
const _hoisted_36 = { class: "col-md-12 col-12" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Logo", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 3,
  class: "progress"
}
const _hoisted_42 = ["aria-valuenow"]
const _hoisted_43 = { class: "col-md-12 col-12" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Name", -1))
const _hoisted_46 = { class: "col-md-12 col-12" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Website", -1))
const _hoisted_49 = { class: "col-md-12 col-12" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company registration number", -1))
const _hoisted_52 = { class: "col-md-12 col-12" }
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Investment Currency", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "col-md-12 col-12" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Expected investment amount", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$500k-$50 million" }, "$500k-$50 million", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$50-$100 million" }, "$50-$100 million", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "$100 million +" }, "$100 million +", -1))
const _hoisted_64 = { class: "col-md-12 col-12" }
const _hoisted_65 = { class: "form-group" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country in which the Company was formed, incorporated or registered", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "col-md-12 col-12" }
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Applicant Domicile Country (Country)", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "col-md-12 col-12" }
const _hoisted_75 = { class: "form-group" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type of company", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Partnership", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Private", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Public", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Trust", -1))
const _hoisted_82 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Trust Deed", -1))
const _hoisted_85 = ["innerHTML"]
const _hoisted_86 = {
  key: 3,
  class: "progress"
}
const _hoisted_87 = ["aria-valuenow"]
const _hoisted_88 = { class: "col-md-12 col-12" }
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company year of Incorporation", -1))
const _hoisted_91 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_92 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_93 = { class: "col-3 px-1" }
const _hoisted_94 = { class: "col-3 px-1" }
const _hoisted_95 = { class: "col-3 px-1" }
const _hoisted_96 = { class: "row my-3 justify-content-center" }
const _hoisted_97 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_98 = { class: "login-card" }
const _hoisted_99 = { class: "login-body business" }
const _hoisted_100 = { class: "row mt-3" }
const _hoisted_101 = { class: "col-md-12 col-12" }
const _hoisted_102 = { class: "form-group" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Corporate Assesment Nature", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Foreign", -1))
const _hoisted_107 = { class: "col-md-12 col-12" }
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type of Corporation", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_111 = {
  key: 0,
  value: "1"
}
const _hoisted_112 = {
  key: 1,
  value: "2"
}
const _hoisted_113 = {
  key: 2,
  value: "3"
}
const _hoisted_114 = {
  key: 3,
  value: "4"
}
const _hoisted_115 = { class: "col-md-12 col-12" }
const _hoisted_116 = { class: "form-group" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "All Business name used by the company", -1))
const _hoisted_118 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_119 = { class: "form-group" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full name of the Company as registered by the Australian Securities and Investments Commission", -1))
const _hoisted_121 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_122 = { class: "form-group" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Company Registered by the relevant foreign registration body ?", -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_foreign_registered0"
}, " Yes ", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "is_foreign_registered1"
}, " No ", -1))
const _hoisted_127 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_128 = { class: "form-group" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company is registered as:", -1))
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Public", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Proprietary", -1))
const _hoisted_133 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_134 = { class: "form-group" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Identification number issued to Company by the relevant foreign registration body upon formation, incorporation or registration", -1))
const _hoisted_136 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_137 = { class: "form-group" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full address of the Company's principal place of business in its country of formation or incorporation ", -1))
const _hoisted_139 = { class: "form-group place_suggest_c_a d-none" }
const _hoisted_140 = {
  class: "card place_suggest_c_a",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_141 = ["onClick"]
const _hoisted_142 = ["id"]
const _hoisted_143 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_144 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_146 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_147 = { class: "form-group" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full address of the Company in its country of formation, incorporation or registration as registered by the relevant foreign registration body", -1))
const _hoisted_149 = { class: "form-group place_suggest_c_a d-none" }
const _hoisted_150 = {
  class: "card place_suggest_c_a",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_151 = ["onClick"]
const _hoisted_152 = ["id"]
const _hoisted_153 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_154 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_156 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_157 = { class: "form-group" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Address of principal place of business", -1))
const _hoisted_159 = { class: "form-group place_suggest_pr_a d-none" }
const _hoisted_160 = {
  class: "card place_suggest_pr_a",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_161 = ["onClick"]
const _hoisted_162 = ["id"]
const _hoisted_163 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_164 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_166 = {
  key: 7,
  class: "col-md-12 col-12"
}
const _hoisted_167 = { class: "form-group" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Full address of the Company’s registered office", -1))
const _hoisted_169 = { class: "form-group place_suggest_ra_o d-none" }
const _hoisted_170 = {
  class: "card place_suggest_ra_o",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_171 = ["onClick"]
const _hoisted_172 = ["id"]
const _hoisted_173 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_174 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_176 = {
  key: 8,
  class: "col-md-12 col-12"
}
const _hoisted_177 = { class: "form-group" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "ACN issued to the company", -1))
const _hoisted_179 = {
  key: 9,
  class: "col-md-12 col-12"
}
const _hoisted_180 = { class: "form-group" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company is registered as ", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Public", -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Proprietary", -1))
const _hoisted_185 = { class: "col-md-12 col-12" }
const _hoisted_186 = { class: "form-group" }
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Business Nature (Major business)", -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Accredited Investor", -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "High Net-worth Individual", -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Sophisticated Investor", -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Wholesale Investor", -1))
const _hoisted_193 = { class: "col-md-12 col-12" }
const _hoisted_194 = { class: "form-group" }
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Describe the business activity", -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Capital Markets", -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Commodities", -1))
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Financial Markets", -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Others", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "Real Estate", -1))
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "Stock Market", -1))
const _hoisted_203 = {
  key: 10,
  class: "col-md-12 col-12"
}
const _hoisted_204 = { class: "form-group" }
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Please mention business activity", -1))
const _hoisted_206 = { class: "col-md-12 col-12" }
const _hoisted_207 = { class: "form-group" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Source of the funds including its origin", -1))
const _hoisted_209 = { class: "col-md-12 col-12" }
const _hoisted_210 = { class: "form-group" }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Nature and level of the intended transaction behaviour", -1))
const _hoisted_212 = { class: "col-md-12 col-12" }
const _hoisted_213 = { class: "form-group" }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Details of any current or recent prosecutions and inquiries related to Money Laundering, terrorist links, tax offences and corruption in respect of the Company", -1))
const _hoisted_215 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_216 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_217 = { class: "col-3 px-1" }
const _hoisted_218 = { class: "col-3 px-1" }
const _hoisted_219 = { class: "col-3 px-1" }
const _hoisted_220 = { class: "row my-3 justify-content-center" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "login-body company" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" })
    ])
  ])
], -1))
const _hoisted_222 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_223 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_224 = { class: "col-3 px-1" }
const _hoisted_225 = { class: "col-3 px-1" }
const _hoisted_226 = { class: "row my-3 justify-content-center" }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "login-card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "login-body company" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" })
    ])
  ])
], -1))
const _hoisted_228 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_229 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_230 = { class: "col-3 px-1" }
const _hoisted_231 = { class: "col-3 px-1" }
const _hoisted_232 = { class: "row my-3 justify-content-center" }
const _hoisted_233 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_234 = { class: "login-card" }
const _hoisted_235 = { class: "login-body company" }
const _hoisted_236 = { class: "row mt-3" }
const _hoisted_237 = { class: "col-md-12 col-12" }
const _hoisted_238 = { class: "form-group" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_240 = { class: "col-md-12 col-12" }
const _hoisted_241 = { class: "form-group" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_243 = { class: "col-md-12 col-12" }
const _hoisted_244 = { class: "form-group" }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_246 = { class: "col-md-12 col-12" }
const _hoisted_247 = { class: "form-group" }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth", -1))
const _hoisted_249 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_250 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_251 = { class: "col-3 px-1" }
const _hoisted_252 = { class: "col-3 px-1" }
const _hoisted_253 = { class: "col-3 px-1" }
const _hoisted_254 = { class: "row my-3 justify-content-center" }
const _hoisted_255 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_256 = { class: "login-card" }
const _hoisted_257 = { class: "login-body company" }
const _hoisted_258 = { class: "row mt-3" }
const _hoisted_259 = { class: "form-group" }
const _hoisted_260 = { class: "font-grey" }
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_262 = ["onClick"]
const _hoisted_263 = ["innerHTML"]
const _hoisted_264 = {
  key: 3,
  class: "progress"
}
const _hoisted_265 = ["aria-valuenow"]
const _hoisted_266 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }
const _hoisted_267 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_268 = { class: "col-3 px-1" }
const _hoisted_269 = { class: "col-3 px-1" }
const _hoisted_270 = { class: "col-3 px-1" }
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade sending_email",
  id: "sending_email",
  role: "dialog"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-sm modal-dialog-centered",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content bg-light" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "row mx-1 mt-4" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
            /*#__PURE__*/_createElementVNode("p", null, "Sending document to your mail ! Please Wait.....")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_272 = {
  class: "modal fade cancel_request",
  id: "cancel_request",
  role: "dialog"
}
const _hoisted_273 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_274 = { class: "modal-content" }
const _hoisted_275 = { class: "modal-body mb-2" }
const _hoisted_276 = { class: "row mx-1 mt-1" }
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Cancelling will delete all details entered.")
], -1))
const _hoisted_278 = { class: "col-md-12 text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Directors = _resolveComponent("Directors")!
  const _component_Owners = _resolveComponent("Owners")!
  const _component_Banks = _resolveComponent("Banks")!
  const _component_toasti = _resolveComponent("toasti")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("ul", _hoisted_12, [
                      _createElementVNode("li", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.set_step(1);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='company'}])
                      }, _hoisted_14, 2),
                      _createElementVNode("li", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.set_step(2);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='business'}])
                      }, _hoisted_16, 2),
                      (_ctx.md_owner_active==1)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            title: "Managin Directos and Beneficial Owners",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.set_step(2.5);}),
                            class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='md_owner'}])
                          }, _hoisted_18, 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.set_step(3);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='account'}])
                      }, _hoisted_20, 2),
                      _createElementVNode("li", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.set_step(4);}),
                        class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='e_signature'}])
                      }, _hoisted_22, 2),
                      (_ctx.final_step==5)
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 1,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.set_step(5);}),
                            class: _normalizeClass(["p-cursor", {'is-active':_ctx.active_tab=='upload'}])
                          }, _hoisted_24, 2))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              (this.current_step==1)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 0,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createVNode(_component_Field, {
                                  modelValue: this.active_tab,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.active_tab) = $event)),
                                  name: "user_type",
                                  id: "user_type",
                                  type: "hidden"
                                }, null, 8, ["modelValue"]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.user_ref_no,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.user_ref_no) = $event)),
                                      placeholder: "ie. CM0011114",
                                      class: "form-control selected-field",
                                      name: "user_ref_no",
                                      id: "user_ref_no",
                                      type: "text",
                                      readonly: ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "user_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createVNode(_component_Field, {
                                      readonly: _ctx.advisor_exist==1,
                                      modelValue: _ctx.form.advisor_ref_no,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.advisor_ref_no) = $event)),
                                      placeholder: "ie. A042",
                                      class: "form-control selected-field",
                                      name: "advisor_ref_no",
                                      id: "advisor_ref_no",
                                      type: "text"
                                    }, null, 8, ["readonly", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "advisor_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("div", _hoisted_37, [
                                    _hoisted_38,
                                    _hoisted_39,
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file"
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    (typeof _ctx.records.profile_pic_url=='undefined' || _ctx.records.profile_pic_url=='')
                                      ? (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.uploadFile($event))),
                                          modelValue: _ctx.form.profile_pic,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.profile_pic) = $event)),
                                          class: "form-control selected-field",
                                          name: "profile_pic",
                                          type: "file",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic"
                                    }),
                                    (typeof _ctx.records.profile_pic_url!='undefined' && _ctx.records.profile_pic_url!='')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "p-cursor",
                                          onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.openDoc(_ctx.records.profile_pic_url);})
                                        }, [
                                          _createElementVNode("img", {
                                            class: "rounded-circle",
                                            style: {"height":"50px"},
                                            src: _ctx.records.profile_pic_url
                                          }, null, 8, _hoisted_40)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.form['profile_pic_pdiv']==1)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                          _createElementVNode("div", {
                                            class: "progress-bar bg-dark",
                                            role: "progressbar",
                                            style: _normalizeStyle({'width':_ctx.form['profile_pic_pbar']+'%'}),
                                            "aria-valuenow": _ctx.form['profile_pic_pbar'],
                                            "aria-valuemin": "0",
                                            "aria-valuemax": "100"
                                          }, _toDisplayString(_ctx.form['profile_pic_pbar_p']), 13, _hoisted_42)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Field, {
                                      rules: _ctx.requiredField,
                                      modelValue: _ctx.form['profile_pic_path'],
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form['profile_pic_path']) = $event)),
                                      class: "form-control selected-field",
                                      name: "profile_pic_path",
                                      type: "hidden"
                                    }, null, 8, ["rules", "modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "profile_pic_path"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _hoisted_45,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_name,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.company_name) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_name",
                                      placeholder: "your company name here",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_website,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.company_website) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_website",
                                      placeholder: "ie. www.caprock.com",
                                      type: "text",
                                      rules: []
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_website"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_registration_no,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.company_registration_no) = $event)),
                                      class: "form-control selected-field",
                                      name: "company_registration_no",
                                      placeholder: "ie. IRGE345678",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_registration_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, [
                                    _hoisted_54,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_currency,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.investment_currency) = $event)),
                                      class: "form-control",
                                      name: "investment_currency",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_55,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.currency) + " - " + _toDisplayString(country.country_name), 9, _hoisted_56))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_currency"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _hoisted_59,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.investment_amount,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.investment_amount) = $event)),
                                      class: "form-control",
                                      name: "investment_amount",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_60,
                                        _hoisted_61,
                                        _hoisted_62,
                                        _hoisted_63
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "investment_amount"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _hoisted_66,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.incorporation_country,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.incorporation_country) = $event)),
                                      class: "form-control",
                                      name: "incorporation_country",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_67,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.country_name), 9, _hoisted_68))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "incorporation_country"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _hoisted_71,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.domicile_country,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.domicile_country) = $event)),
                                      class: "form-control",
                                      name: "domicile_country",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_72,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.country_name), 9, _hoisted_73))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "domicile_country"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("div", _hoisted_75, [
                                    _hoisted_76,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.company_type,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.company_type) = $event)),
                                      class: "form-control",
                                      name: "company_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_77,
                                        _hoisted_78,
                                        _hoisted_79,
                                        _hoisted_80,
                                        _hoisted_81
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "company_type"
                                    })
                                  ])
                                ]),
                                (_ctx.form.company_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                      _createElementVNode("div", _hoisted_83, [
                                        _hoisted_84,
                                        (typeof _ctx.records.trust_deed_url!='undefined' && _ctx.records.trust_deed_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.trust_deed,
                                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.trust_deed) = $event)),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.records.trust_deed_url=='undefined' || _ctx.records.trust_deed_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.form.trust_deed,
                                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.trust_deed) = $event)),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["modelValue", "rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "trust_deed"
                                        }),
                                        (typeof _ctx.records.trust_deed_url!='undefined' && _ctx.records.trust_deed_url!='')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[27] || (_cache[27] = ($event: any) => {_ctx.openDoc(_ctx.records.trust_deed_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_85),
                                              _createTextVNode(" Trust Deed ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.trust_deed_pdiv==1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                              _createElementVNode("div", {
                                                class: "progress-bar bg-dark",
                                                role: "progressbar",
                                                style: _normalizeStyle({'width':_ctx.form.trust_deed_pbar+'%'}),
                                                "aria-valuenow": _ctx.form.trust_deed_pbar,
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }, _toDisplayString(_ctx.form.trust_deed_pbar_p), 13, _hoisted_87)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_Field, {
                                          rules: _ctx.requiredField,
                                          modelValue: _ctx.form.trust_deed_path,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.trust_deed_path) = $event)),
                                          class: "form-control selected-field",
                                          name: "trust_deed_path",
                                          type: "hidden"
                                        }, null, 8, ["rules", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "trust_deed_path"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("div", _hoisted_89, [
                                    _hoisted_90,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.incorporation_date,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.incorporation_date) = $event)),
                                      type: "date",
                                      class: "form-control selected-field",
                                      name: "incorporation_date",
                                      placeholder: "ie. Incorporation Date",
                                      rules: [_ctx.requiredField],
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "incorporation_date"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("button", {
                                onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.next_step=1;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("button", {
                                onClick: _cache[32] || (_cache[32] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 1,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createElementVNode("div", _hoisted_100, [
                                _createElementVNode("div", _hoisted_101, [
                                  _createElementVNode("div", _hoisted_102, [
                                    _hoisted_103,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.corporate_nature,
                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.corporate_nature) = $event)),
                                      class: "form-control",
                                      name: "corporate_nature",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_104,
                                        _hoisted_105,
                                        _hoisted_106
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "corporate_nature"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _hoisted_109,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.corporation_type,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.corporation_type) = $event)),
                                      class: "form-control",
                                      name: "corporation_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_110,
                                        (_ctx.form.corporate_nature==1)
                                          ? (_openBlock(), _createElementBlock("option", _hoisted_111, "Australian Company"))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.corporate_nature==1)
                                          ? (_openBlock(), _createElementBlock("option", _hoisted_112, "ASIC Registered Australian Company"))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.corporate_nature==2)
                                          ? (_openBlock(), _createElementBlock("option", _hoisted_113, "ASIC Registered Foreign Company"))
                                          : _createCommentVNode("", true),
                                        (_ctx.form.corporate_nature==2)
                                          ? (_openBlock(), _createElementBlock("option", _hoisted_114, "ASIC Unregistered Foreign Company"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "corporation_type"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_115, [
                                  _createElementVNode("div", _hoisted_116, [
                                    _hoisted_117,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.business_names,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.business_names) = $event)),
                                      class: "form-control selected-field",
                                      name: "business_names",
                                      placeholder: "ie. Business 1, Business2 ",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "business_names"
                                    })
                                  ])
                                ]),
                                (_ctx.form.corporation_type==2 || _ctx.form.corporation_type==3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                      _createElementVNode("div", _hoisted_119, [
                                        _hoisted_120,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.australian_company_name,
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.australian_company_name) = $event)),
                                          class: "form-control selected-field",
                                          name: "australian_company_name",
                                          placeholder: "ie. Company Name",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "australian_company_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.corporation_type==3 || _ctx.form.corporation_type==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                      _createElementVNode("div", _hoisted_122, [
                                        _hoisted_123,
                                        _createTextVNode(),
                                        _hoisted_124,
                                        _createVNode(_component_Field, {
                                          id: "is_foreign_registered0",
                                          modelValue: _ctx.form.is_foreign_registered,
                                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.is_foreign_registered) = $event)),
                                          class: "mx-2",
                                          name: "is_foreign_registered",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_125,
                                        _createVNode(_component_Field, {
                                          id: "is_foreign_registered1",
                                          modelValue: _ctx.form.is_foreign_registered,
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.is_foreign_registered) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_foreign_registered",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_126,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_foreign_registered"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.is_foreign_registered==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                                      _createElementVNode("div", _hoisted_128, [
                                        _hoisted_129,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.company_reg_type,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.company_reg_type) = $event)),
                                          class: "form-control",
                                          name: "company_reg_type",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_130,
                                            _hoisted_131,
                                            _hoisted_132
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "company_reg_type"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.is_foreign_registered==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                      _createElementVNode("div", _hoisted_134, [
                                        _hoisted_135,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.company_identiciation_no,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.company_identiciation_no) = $event)),
                                          class: "form-control selected-field",
                                          name: "company_identiciation_no",
                                          placeholder: "ie. IS5678",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "company_identiciation_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.is_foreign_registered!=1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                      _createElementVNode("div", _hoisted_137, [
                                        _hoisted_138,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[41] || (_cache[41] = ($event: any) => {_ctx.textSearch($event,'_c_a');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.company_address,
                                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.form.company_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "company_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "company_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_139, [
                                        _createElementVNode("div", _hoisted_140, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'company_address','_c_a');},
                                              class: "suggestDiv_c_a"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_142),
                                              _createElementVNode("h6", _hoisted_143, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_144, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_141))
                                          }), 128)),
                                          _hoisted_145
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.is_foreign_registered==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                      _createElementVNode("div", _hoisted_147, [
                                        _hoisted_148,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[43] || (_cache[43] = ($event: any) => {_ctx.textSearch($event,'_c_a');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.company_address,
                                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.form.company_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "company_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "company_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_149, [
                                        _createElementVNode("div", _hoisted_150, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'company_address','_c_a');},
                                              class: "suggestDiv_c_a"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_152),
                                              _createElementVNode("h6", _hoisted_153, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_154, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_151))
                                          }), 128)),
                                          _hoisted_155
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.corporation_type==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                      _createElementVNode("div", _hoisted_157, [
                                        _hoisted_158,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[45] || (_cache[45] = ($event: any) => {_ctx.textSearch($event,'_pr_a');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.principal_address,
                                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.form.principal_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "principal_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "principal_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_159, [
                                        _createElementVNode("div", _hoisted_160, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'principal_address','_pr_a');},
                                              class: "suggestDiv_pr_a"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_162),
                                              _createElementVNode("h6", _hoisted_163, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_164, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_161))
                                          }), 128)),
                                          _hoisted_165
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.corporation_type==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_166, [
                                      _createElementVNode("div", _hoisted_167, [
                                        _hoisted_168,
                                        _createVNode(_component_Field, {
                                          onKeyup: _cache[47] || (_cache[47] = ($event: any) => {_ctx.textSearch($event,'_ra_o');}),
                                          onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                          autocomplete: "off",
                                          modelValue: _ctx.form.registered_address,
                                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.form.registered_address) = $event)),
                                          class: "form-control selected-field",
                                          name: "registered_address",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "registered_address"
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_169, [
                                        _createElementVNode("div", _hoisted_170, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: item.id,
                                              onClick: ($event: any) => {_ctx.set_address(item.id,'registered_address','_ra_o');},
                                              class: "suggestDiv_ra_o"
                                            }, [
                                              _createElementVNode("div", {
                                                class: "d-none",
                                                id: 'addr_'+item.id
                                              }, _toDisplayString(item.address), 9, _hoisted_172),
                                              _createElementVNode("h6", _hoisted_173, _toDisplayString(item.title), 1),
                                              _createElementVNode("p", _hoisted_174, _toDisplayString(item.details), 1)
                                            ], 8, _hoisted_171))
                                          }), 128)),
                                          _hoisted_175
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.corporation_type==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                      _createElementVNode("div", _hoisted_177, [
                                        _hoisted_178,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.company_ACN,
                                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.form.company_ACN) = $event)),
                                          class: "form-control selected-field",
                                          name: "company_ACN",
                                          placeholder: "ie. 051 75454 4",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "company_ACN"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.form.corporation_type==2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      _createElementVNode("div", _hoisted_180, [
                                        _hoisted_181,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.company_registration_type,
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.form.company_registration_type) = $event)),
                                          class: "form-control",
                                          name: "company_registration_type",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_182,
                                            _hoisted_183,
                                            _hoisted_184
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "company_registration_type"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_185, [
                                  _createElementVNode("div", _hoisted_186, [
                                    _hoisted_187,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.business_nature,
                                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.form.business_nature) = $event)),
                                      class: "form-control",
                                      name: "business_nature",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_188,
                                        _hoisted_189,
                                        _hoisted_190,
                                        _hoisted_191,
                                        _hoisted_192
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "business_nature"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_193, [
                                  _createElementVNode("div", _hoisted_194, [
                                    _hoisted_195,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.business_activity,
                                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.form.business_activity) = $event)),
                                      class: "form-control",
                                      name: "business_activity",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_196,
                                        _hoisted_197,
                                        _hoisted_198,
                                        _hoisted_199,
                                        _hoisted_200,
                                        _hoisted_201,
                                        _hoisted_202
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "business_activity"
                                    })
                                  ])
                                ]),
                                (_ctx.form.business_activity==4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                                      _createElementVNode("div", _hoisted_204, [
                                        _hoisted_205,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.business_activity_other,
                                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.form.business_activity_other) = $event)),
                                          class: "form-control selected-field",
                                          name: "business_activity_other",
                                          placeholder: "ie. IT Services",
                                          type: "text",
                                          rules: [_ctx.requiredField]
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "business_activity_other"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_206, [
                                  _createElementVNode("div", _hoisted_207, [
                                    _hoisted_208,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.funding_source,
                                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.form.funding_source) = $event)),
                                      class: "form-control selected-field",
                                      name: "funding_source",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "funding_source"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_209, [
                                  _createElementVNode("div", _hoisted_210, [
                                    _hoisted_211,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.transaction_behaviour,
                                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.form.transaction_behaviour) = $event)),
                                      class: "form-control selected-field",
                                      name: "transaction_behaviour",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "transaction_behaviour"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_212, [
                                  _createElementVNode("div", _hoisted_213, [
                                    _hoisted_214,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.mal_activity,
                                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.form.mal_activity) = $event)),
                                      class: "form-control selected-field",
                                      name: "mal_activity",
                                      placeholder: "",
                                      type: "text",
                                      rules: [_ctx.requiredField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "mal_activity"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_215, [
                          _createElementVNode("div", _hoisted_216, [
                            _createElementVNode("div", _hoisted_217, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_218, [
                              _createElementVNode("button", {
                                onClick: _cache[58] || (_cache[58] = ($event: any) => {_ctx.next_step=2;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_219, [
                              _createElementVNode("button", {
                                onClick: _cache[59] || (_cache[59] = ($event: any) => {_ctx.next_step=2.5;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==2.5 && (_ctx.form.corporation_type==2 || _ctx.form.corporation_type==3))
                ? (_openBlock(), _createBlock(_component_Directors, {
                    key: 2,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==2.5 && (_ctx.form.corporation_type==3 || _ctx.form.corporation_type==4))
                ? (_openBlock(), _createBlock(_component_Owners, {
                    key: 3,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==2.5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 4,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_2_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_220, [
                        _hoisted_221,
                        _createElementVNode("div", _hoisted_222, [
                          _createElementVNode("div", _hoisted_223, [
                            _createElementVNode("div", _hoisted_224, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_225, [
                              _createElementVNode("button", {
                                onClick: _cache[61] || (_cache[61] = ($event: any) => {_ctx.next_step=3;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Banks, {
                    key: 5,
                    countries: _ctx.countries,
                    current_step: _ctx.current_step,
                    load_on: _ctx.load_on
                  }, null, 8, ["countries", "current_step", "load_on"]))
                : _createCommentVNode("", true),
              (this.current_step==3)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 6,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_226, [
                        _hoisted_227,
                        _createElementVNode("div", _hoisted_228, [
                          _createElementVNode("div", _hoisted_229, [
                            _createElementVNode("div", _hoisted_230, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_231, [
                              _createElementVNode("button", {
                                onClick: _cache[63] || (_cache[63] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==4)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 7,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_232, [
                        _createElementVNode("div", _hoisted_233, [
                          _createElementVNode("div", _hoisted_234, [
                            _createElementVNode("div", _hoisted_235, [
                              _createElementVNode("div", _hoisted_236, [
                                _createElementVNode("div", _hoisted_237, [
                                  _createElementVNode("div", _hoisted_238, [
                                    _hoisted_239,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_name,
                                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.form.esign_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "esign_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_240, [
                                  _createElementVNode("div", _hoisted_241, [
                                    _hoisted_242,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_email_id,
                                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.form.esign_email_id) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "esign_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_243, [
                                  _createElementVNode("div", _hoisted_244, [
                                    _hoisted_245,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_phone_no,
                                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.form.esign_phone_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "esign_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_246, [
                                  _createElementVNode("div", _hoisted_247, [
                                    _hoisted_248,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.form.esign_dob,
                                      "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.form.esign_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "esign_dob",
                                      type: "date",
                                      rules: _ctx.requiredField,
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                      placeholder: "D.O.B"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "esign_dob"
                                    })
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_249, [
                          _createElementVNode("div", _hoisted_250, [
                            _createElementVNode("div", _hoisted_251, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_252, [
                              _createElementVNode("button", {
                                onClick: _cache[69] || (_cache[69] = ($event: any) => {_ctx.next_step=4;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_253, [
                              _createElementVNode("button", {
                                onClick: _cache[70] || (_cache[70] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Next ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true),
              (this.current_step==5  && _ctx.final_step==5)
                ? (_openBlock(), _createBlock(_component_Form, {
                    key: 8,
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.submitForm_5
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_254, [
                        _createElementVNode("div", _hoisted_255, [
                          _createElementVNode("div", _hoisted_256, [
                            _createElementVNode("div", _hoisted_257, [
                              _createElementVNode("div", _hoisted_258, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.final_docs, (upload_doc) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "col-md-12 col-12",
                                    key: upload_doc.input_name
                                  }, [
                                    _createElementVNode("div", _hoisted_259, [
                                      _createElementVNode("label", _hoisted_260, _toDisplayString(upload_doc.name), 1),
                                      _hoisted_261,
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 0,
                                            onChange: _cache[71] || (_cache[71] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form.driver_license,
                                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.form.driver_license) = $event)),
                                            class: "form-control selected-field",
                                            name: "driver_license",
                                            type: "file"
                                          }, null, 8, ["modelValue"]))
                                        : _createCommentVNode("", true),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']=='undefined' || _ctx.records[upload_doc.input_name+'_url']=='')
                                        ? (_openBlock(), _createBlock(_component_Field, {
                                            key: 1,
                                            onChange: _cache[73] || (_cache[73] = ($event: any) => (_ctx.uploadFile($event))),
                                            modelValue: _ctx.form[upload_doc.input_name],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name]) = $event),
                                            class: "form-control selected-field",
                                            name: upload_doc.input_name,
                                            type: "file",
                                            rules: _ctx.requiredField
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "rules"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name
                                      }, null, 8, ["name"]),
                                      (typeof _ctx.records[upload_doc.input_name+'_url']!='undefined' && _ctx.records[upload_doc.input_name+'_url']!='')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: "p-cursor",
                                            onClick: ($event: any) => {_ctx.openDoc(_ctx.records[upload_doc.input_name+'_url']);}
                                          }, [
                                            _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_263),
                                            _createTextVNode(" " + _toDisplayString(upload_doc.name), 1)
                                          ], 8, _hoisted_262))
                                        : _createCommentVNode("", true),
                                      (_ctx.form[upload_doc.input_name+'_pdiv']==1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                                            _createElementVNode("div", {
                                              class: "progress-bar bg-dark",
                                              role: "progressbar",
                                              style: _normalizeStyle({'width':_ctx.form[upload_doc.input_name+'_pbar']+'%'}),
                                              "aria-valuenow": _ctx.form[upload_doc.input_name+'_pbar'],
                                              "aria-valuemin": "0",
                                              "aria-valuemax": "100"
                                            }, _toDisplayString(_ctx.form[upload_doc.input_name+'_pbar_p']), 13, _hoisted_265)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_component_Field, {
                                        rules: _ctx.requiredField,
                                        modelValue: _ctx.form[upload_doc.input_name+'_path'],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[upload_doc.input_name+'_path']) = $event),
                                        class: "form-control selected-field",
                                        name: upload_doc.input_name+'_path',
                                        type: "hidden"
                                      }, null, 8, ["rules", "modelValue", "onUpdate:modelValue", "name"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: upload_doc.input_name+'_path'
                                      }, null, 8, ["name"])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_266, [
                          _createElementVNode("div", _hoisted_267, [
                            _createElementVNode("div", _hoisted_268, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.openModal('cancel_request'))),
                                class: "btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Cancel ")
                            ]),
                            _createElementVNode("div", _hoisted_269, [
                              _createElementVNode("button", {
                                onClick: _cache[75] || (_cache[75] = ($event: any) => {_ctx.next_step=5;}),
                                type: "submit",
                                class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save ")
                            ]),
                            _createElementVNode("div", _hoisted_270, [
                              _createElementVNode("button", {
                                onClick: _cache[76] || (_cache[76] = ($event: any) => {_ctx.next_step=200;}),
                                type: "submit",
                                class: "subBtn btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
                              }, " Save & Finish ")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_271,
    _createElementVNode("div", _hoisted_272, [
      _createElementVNode("div", _hoisted_273, [
        _createElementVNode("div", _hoisted_274, [
          _createElementVNode("div", _hoisted_275, [
            _createElementVNode("div", _hoisted_276, [
              _hoisted_277,
              _createElementVNode("div", _hoisted_278, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.cancel_request(2)))
                }, "Ok"),
                _createElementVNode("button", {
                  onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.closeModal('cancel_request'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_toasti, { ref: "toasti" }, null, 512)
  ], 64))
}